module.exports = __webpack_public_path__ + "static/media/deleteResource.571de44c.svg";